import Back from '../Back';
import Content from '../Content';
import NoData from '../NoData';
import Properties from '../Properties';
import styles from '../common/DevTools.module.scss';
import createPropertyRecord from '../helpers/createPropertyRecord';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { CartesianGrid, Line, LineChart, XAxis, YAxis } from 'recharts';

const Color = ({ payload }) => {
  const data = useSelector((state) => {
    const colors = state.measures.colors;
    const waveLengths = state.measures.waveLengths;
    const color = colors.find((c) => c.id === payload.id);

    if (!color) {
      return null;
    }

    const items = [];

    color.absorption.impasto.forEach((_, index) => {
      items.push({
        wave: waveLengths[index],
        impasto: color.absorption.impasto[index],
        glaze: color.absorption.glaze[index],
      });
    });

    return {
      color,
      diagram: items,
    };
  });

  const properties = useMemo(() => {
    if (!data) {
      return null;
    }

    return [
      createPropertyRecord(`colorModelLimit`, 'modelLimit', data.color.modelLimit, 'float', true),
      createPropertyRecord(`colorColor`, 'color', data.color.color, 'integer', true),
    ];
  }, [data]);

  if (!data) {
    return <NoData />;
  }

  return (
    <>
      <Back title={data.color.name} index={payload.menuIndex} />

      <Content>
        <div className={styles.header}>
          <div className={styles.color} style={{ backgroundColor: data.color.color }}></div>
          <div className={styles.data}>
            <div className={styles.left}>
              <div className={styles.title}>{data.color.name}</div>
              <div className={styles.subTitle}>{data.color.id}</div>
            </div>
          </div>
        </div>

        <Properties data={properties} title="Properties" showDiff={false} />

        <div>
          <div className={styles.diagram}>
            <div className={styles.diagramName}>Reflectance</div>

            <div className={styles.diagramChart}>
              <LineChart width={305} height={110} data={data.diagram} margin={{ left: -30 }}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="wave" tick={{ fontSize: 10 }} />
                <YAxis tick={{ fontSize: 10 }} />
                <Line type="monotone" dataKey="impasto" stroke="white" isAnimationActive={false} dot={false} />
                <Line type="monotone" dataKey="glaze" stroke="#74abd7" isAnimationActive={false} dot={false} />
              </LineChart>
            </div>
          </div>
          <ul className={styles.legend}>
            <li>
              <div
                className={styles.legendColor}
                style={{
                  backgroundColor: 'white',
                }}
              />
              impasto
            </li>
            <li>
              <div
                className={styles.legendColor}
                style={{
                  backgroundColor: '#74abd7',
                }}
              />
              glaze
            </li>
          </ul>
        </div>
      </Content>
    </>
  );
};

export default Color;
